// 传说
import { EquipMain } from "../equipmentType";
// import { propertyName, propertyAttr } from "@/const/character";
// 武器池
const equipPoolListW: EquipMain[] = [];
// 防具池
const equipPoolListA: EquipMain[] = [];
// 首饰池
const equipPoolListJ: EquipMain[] = [];

const equipsGrade4: EquipMain[] = [
  ...equipPoolListW,
  ...equipPoolListA,
  ...equipPoolListJ
];
export { equipsGrade4 };
